import type {InferResponseType} from 'hono/client';
import type {ItemStatePayload, StarredResource} from '../../types/types.ts';
import {api} from './api-client.ts';
import type {ApiErrorResponse, ApiOKResponse} from './http.ts';
import {handleRpcResponse} from './http.ts';

type SaveItemStateResponse = InferResponseType<(typeof api)['article-state']['$post']>;

export async function saveItemState(
	state: ItemStatePayload
): Promise<ApiOKResponse<SaveItemStateResponse> | ApiErrorResponse> {
	return handleRpcResponse<SaveItemStateResponse>(
		api['article-state'].$post({
			json: {
				id: state.id,
				state: state.state,
				starred: state.starred,
				mobileProgress: state.mobileProgress,
				desktopProgress: state.desktopProgress
			}
		})
	);
}

export async function loadStarredResources(): Promise<ApiOKResponse<StarredResource[]> | ApiErrorResponse> {
	return handleRpcResponse<StarredResource[]>(api['starred-resources'].$get());
}

type SaveStarredResourcesResponse = InferResponseType<(typeof api)['starred-resources']['$post']>;

export async function saveStarredResources(
	data: StarredResource[]
): Promise<ApiOKResponse<SaveStarredResourcesResponse> | ApiErrorResponse> {
	return handleRpcResponse<SaveStarredResourcesResponse>(api['starred-resources'].$post({json: data}));
}

export async function loadEditionStates(
	editionId: string
): Promise<ApiOKResponse<Record<string, ItemStatePayload>> | ApiErrorResponse> {
	return handleRpcResponse<Record<string, ItemStatePayload>>(
		api.editions[':id']['article-states'].$get({param: {id: editionId}})
	);
}

export async function loadStatesById(
	ids: string[]
): Promise<ApiOKResponse<Record<string, ItemStatePayload>> | ApiErrorResponse> {
	return handleRpcResponse<Record<string, ItemStatePayload>>(api['article-states']['query'].$post({json: {ids}}));
}
